<template>
  <b-row class="printer-details-container ">
     <b-col>
        <a :href="'#printer-details-'+printerlocation.id" draggable="false" class='wrapper-a' @click="clickToExpanding">
          <b-list-group-item>
            <b-row>
              <b-col class="px-0" cols="2" sm="1">
                <div class="toggle-icon"  @click.prevent>
                  <span v-if="isVisible" aria-hidden="true"><b-icon variant="secondary" icon="caret-right-fill" font-scale="2.2" v-b-popover.hover.left="'View Categories'"></b-icon></span>
                  <span v-else aria-hidden="true"><b-icon variant="secondary" icon="caret-down-fill" font-scale="2.2" v-b-popover.hover.left="'View Categories'"></b-icon></span>
                </div>
              </b-col>
              <b-col class="pl-0" cols="4" sm="2">
                  <b-form-input v-model="this.updPL.macaddress" @change="updatePrinterLocation()"></b-form-input>
              </b-col>
              <b-col class="pl-0" cols="4" sm="2">
                  <b-form-input v-model="this.updPL.format" @change="updatePrinterLocation()"></b-form-input>
              </b-col>
              <b-col class="pl-0" cols="4" sm="2">
                <b-form-input v-model="this.updPL.locationname" list="locations" placeholder="Location" @change="updatePrinterLocation()"></b-form-input>
                <!--https://www.raymondcamden.com/2018/04/12/datalists-with-vuejs-->
                <datalist id="locations">
                  <option v-for="location in alllocations" :key="location.id">{{ location.name }}</option>
                </datalist>
              </b-col>
              <b-col cols="1">
                <a :href="'#'+$route.path">
                  <b-icon icon="x-circle" variant="danger" font-scale="2.5" v-b-popover.hover.right="'Delete Printer Location'" @click="confirmPrinterLocationDelete"></b-icon>
                </a>
              </b-col>
            </b-row>

            <b-collapse
            class="category-card"  v-model="isVisible"
             :id="'printer-details-'+ printerlocation.id">
              <b-row class="mt-5">
                <b-col>
                  <h5 style="text-align: center;">Categories</h5>
                  <b-row>
                    <b-col cols="4">
                      <b-form-input v-model="plcategory" list="categories" placeholder="Add Category"></b-form-input>
                      <datalist id="categories">
                        <option v-for="category in categories" :key="category.id">{{ category.name }}</option>
                      </datalist>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="11"><b-button class='add-btn' variant="outline-dark" @click="addCategory()">+</b-button></b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="10"><b-alert v-if="categoryalert" variant="info" v-model="categoryalert" dismissible>Please Select A Category!</b-alert></b-col>
                  </b-row>
                  <b-list-group>
                      <PLCategories
                        v-for="category of this.updPL.categories"
                        v-bind:category="category"
                        v-bind:key="category.id"
                        :printerlocationid="category.printerlocationid"
                        @emit-remove-printer-location-category="deleteCategory">
                      </PLCategories>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-collapse>
          </b-list-group-item>
        </a>
     </b-col>
  </b-row>
</template>
<script>
import PLCategories from '@/components/PrinterLocationCategories.vue'
export default {
  name: 'PrinterLocations',
  components: {
    PLCategories
  },
  props: ['printerlocation','printerlocations','categories','locations'],
  data () {
    return {
      updPL: {
        macaddress: this.printerlocation.macaddress,
        format: this.printerlocation.format,
        printerlocationid: this.printerlocation.id,
        locationid: this.printerlocation.locationid,
        locationname: this.printerlocation.locationname,
        notes: this.printerlocation.notes,
        area: this.printerlocation.area,
        categories: [],
        totalcategories: ''
    },
      categoryalert: false,
      confirmDel: '',
      allcategories: this.categories,
      alllocations: this.locations,
      plmacaddress: '',
      plformat: '',
      printerlocationid: '',
      printerlocationlocationid: '',
      plcategory: '',
      copylist: 0,
      allLists: this.printerlocations,
      urlext: '',
      isVisible: false
    }
  },

  computed: {
  },

  methods: {
     clickToExpanding(event){
      const currentIsVisible = this.isVisible;
      const clickedTag = event.target.tagName;
      if(clickedTag.includes('SPAN') || clickedTag.includes('LABEL') || (clickedTag.includes('INPUT') && event.target.type === 'checkbox' ))
      {
        return ;
      }
      else if(clickedTag.includes('INPUT')|| clickedTag.includes('BUTTON')||clickedTag.includes('SELECT') || ( clickedTag.includes('svg') && (event.target.classList[0] === "bi-x-circle")))
      {
         event.preventDefault();
        this.isVisible = currentIsVisible;
      }
      else{
        event.preventDefault();
        this.isVisible = !currentIsVisible;
      }      
    },
    emitFetchPrinterLocations() {
      this.$emit('emit-fetch-printerlocations');
    },

    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    async retrievePrinterLocationCategories() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      try{
      // Check to see if there items associated with this Category?
      const { data } = await this.$api.get('printerlocations/'+this.updPL.printerlocationid+'/printerlocationcategory', {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      if (data.success == true) {
        this.updPL.categories = data.results;
        this.updPL.totalcategories = data.total;
        this.emitSwitchOverlay(false);
      }
      }
      catch{
        this.$bvModal.msgBoxOk('There was a problem getting printer location categories, please try again later.', {
          title: 'Error getting categories printer location',
          centered: true
        })
      }
    },
    async confirmPrinterLocationDelete() {
        // Check to see if there items associated with this Category? {
            // if not, get a confirmation before deleting
            this.confirmDel = ''
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete printer location: '+this.updPL.printerlocationid+'!', {
              title: 'Please confirm delete',
              centered: true
            })
            // Confirmed - you can delete the category now!
            .then(value => {
              this.confirmDel = value
              if (this.confirmDel == true) {
                this.deletePrinterLocation();
              }
            })
            // Error processing modal
            .catch(err => {
              console.log('an error has occurred. '+ err)
            })
          },

    async deletePrinterLocation() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      try{
      // update order with status of 'ready'
      const { data } = await this.$api.delete('printerlocations/'+this.updPL.printerlocationid,
        config
      );
      if (data.deleted == true) {
        this.emitFetchPrinterLocations();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem deleting the printer location, please try again later.', {
          title: 'Error deleting printer location',
          centered: true
        })
      }
      }
      catch{
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem deleting the printer location, please try again later.', {
          title: 'Error deleting printer location',
          centered: true
        })
      }
    },

    async updatePrinterLocation() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "mac": this.updPL.macaddress,
        "format": this.updPL.format,
        "locationid": this.updPL.locationid
      }
      try{
      // update order with status of 'ready'
      const { data } = await this.$api.patch('printerlocations/'+this.printerlocationid,
        body,
        config
      );
      if (data.success == true) {
        this.emitFetchPrinterLocations();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the printer location, please try again later.', {
          title: 'Error updating printer location',
          centered: true
        })
      }
      }
      catch{
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the printer location, please try again later.', {
          title: 'Error updating printer location',
          centered: true
        })
      }
    },

    async addCategory() {
      if (this.plcategory == '') {
        this.categoryalert = true;
        return;
      }
      this.showoverlay=true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };

      const res1 = this.categories.filter(i => i.name == this.plcategory);
      var categoryid = res1[0].id;

      var body = {
        "categoryid": categoryid,
        "printerlocationid": this.updPL.printerlocationid,
      }
      try{
      // update order with status of 'ready'
      const { data } = await this.$api.post('printerlocationcategory',
        body,
        config
      );
      if (data.created == true) {
        this.plcategory = '';
        this.retrievePrinterLocationCategories();
      } else {
        this.showoverlay=false;
        this.$bvModal.msgBoxOk('There was a problem adding the category to the printer location, please try again later.', {
          title: 'Error adding category to printer location',
          centered: true
        });
      }
      }
      catch{
        this.showoverlay=false;
        this.$bvModal.msgBoxOk('There was a problem adding the category to the printer location, please try again later.', {
          title: 'Error adding category to printer location',
          centered: true
        });
      }
    },

    async deleteCategory(id) {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      try{
      // update order with status of 'ready'
      const { data } = await this.$api.delete('printerlocationcategory/'+id,
        config
      );
      if (data.deleted == true) {
        this.retrievePrinterLocationCategories();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem deleting the category from the printer location, please try again later.', {
          title: 'Error deleting category from printer location',
          centered: true
        })
      }
      }
      catch{
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem deleting the category from the printer location, please try again later.', {
          title: 'Error deleting category from printer location',
          centered: true
        })
      }
    },
  },
  created: function() {
    this.retrievePrinterLocationCategories();
  }
}
</script>

<style scoped>
 .toggle-icon{
   margin : 6px 5px;
 }
  .wrapper-a{
    text-decoration: none;
    color: initial;
  }
  .wrapper-a:hover{
    text-decoration: none;
    color: initial;
  }
  .list-group-item{
    position: relative;
    border: 0.2px solid rgb(238, 238, 238) ;
    margin: 10px 0px;
    border-radius: 6px;
    box-shadow: 0 1px 0px rgb(84 70 35 / 15%), 0 0px 2px 0px rgb(84 70 35 / 15%);
  }
  .list-group-item:hover{
    box-shadow: 0 2px 6px rgb(84 70 35 / 15%), 0 1px 3px rgb(84 70 35 / 15%); 
  }
 
  .item-details-container > .col{
    padding: 0px;
  }
  .draggable-btn{
    position: relative;
    margin: auto 0px;
    cursor: pointer;
  }
  .draggable-btn > * {
    transform: rotateZ(270deg);
  }
  .form-control{
    outline: none;
    border-inline: none;
    border: none;
  }
  .form-control:focus{
    border-color: gray;
    box-shadow: 0 0 0px 1px rgb(109 109 109 / 25%);
    background-color: transparent;
    outline: 0;
  }
</style>
